import React from 'react'
import Typography from '@ui/typography'
import { StyleProp, Text, TextStyle } from 'react-native'
import { Trans } from 'react-i18next'
import { TypographyProps, getStrong } from '@ui/typography/types'
import cn from '@ui/utils/cn'

interface Props extends TypographyProps {
  i18nKey?: string
  ns?: string
  values?: any
  prefix?: string
  text?: string
  className?: string
  classNameBold?: string
  styleBold?: StyleProp<TextStyle>
  styleNormal?: StyleProp<TextStyle>
}

export default function FormattedText({
  i18nKey,
  ns,
  values,
  className,
  classNameBold,
  text,
  styleBold,
  styleNormal,
  ...rest
}: Props) {
  const TypographyBold = (
    <Typography
      variant={getStrong(rest.variant || 'SM')}
      className={cn(classNameBold || className)}
      {...rest}
      style={styleBold}
    />
  )

  if (!i18nKey && !text) {
    return null
  }

  return (
    <Trans
      values={values}
      i18nKey={i18nKey}
      ns={!text ? ns : undefined}
      defaults={text}
      parent={Typography}
      components={{
        br: <Text className={className} style={styleNormal}>{`\n`}</Text>,
        strong: TypographyBold,
        b: TypographyBold,
      }}
      {...rest}
      style={styleNormal}
      className={className}
    />
  )
}
